/**
 * Navigation helper for opening a file's detail (review) page.
 */
import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { routerPaths } from "./routerPaths";

/** Returns a callback that opens a file's detail page. */
export function useOpenFileDetail(): (fileId: string) => void {
    const navigate = useNavigate();
    return useCallback(
        (fileId: string) => {
            navigate(routerPaths.files.detail(fileId));
        },
        [navigate],
    );
}
